import {
  OR_SHOW_PUT_ON_HOLD_MODAL,
  OR_HIDE_PUT_ON_HOLD_MODAL,
  OR_REQUEST_PUT_ON_HOLD,
  OR_PUT_ON_HOLD_SUCCESS,
  OR_PUT_ON_HOLD_ERROR,
  OR_REQUEST_ACTIVATION,
  OR_ACTIVATION_SUCCESS,
  OR_ACTIVATION_ERROR,
  OR_SHOW_CANCEL_SUBSCRIPTION_MODAL,
  OR_HIDE_CANCEL_SUBSCRIPTION_MODAL,
  OR_REQUEST_CANCEL_SUBSCRIPTION,
  OR_SUBSCRIPTION_CANCELLATION_SUCCESS,
  OR_SUBSCRIPTION_CANCELLATION_ERROR,
} from '../../../actions/management/orSettings';

export const initialState = {
  isPutOnHoldInProgress: false,
  isPutOnHoldRequestError: false,
  isPutOnHoldModalVisible: false,

  isActivationInProgress: false,
  isActivationRequestError: false,

  isCancelSubscriptionInProgress: false,
  isCancelSubscriptionError: false,
  isCancelSubscriptionModalVisible: false,
};

const ACTIONS = {
  [OR_SHOW_PUT_ON_HOLD_MODAL]: ({ state }) => ({
    ...state,
    isPutOnHoldModalVisible: true,
    isPutOnHoldRequestError: false,
  }),
  [OR_HIDE_PUT_ON_HOLD_MODAL]: ({ state }) => ({
    ...state,
    isPutOnHoldModalVisible: false,
    isPutOnHoldRequestError: false,
  }),
  [OR_REQUEST_PUT_ON_HOLD]: ({ state }) => ({
    ...state,
    isCancelSubscriptionInProgress: false,
    isCancelSubscriptionError: false,
    isPutOnHoldInProgress: true,
  }),
  [OR_PUT_ON_HOLD_SUCCESS]: ({ state }) => ({
    ...state,
    isPutOnHoldInProgress: false,
    isPutOnHoldRequestError: false,
    isPutOnHoldModalVisible: false,
    isCancelSubscriptionModalVisible: false,
  }),
  [OR_PUT_ON_HOLD_ERROR]: ({ state }) => ({
    ...state,
    isPutOnHoldInProgress: false,
    isPutOnHoldRequestError: true,
  }),
  [OR_REQUEST_ACTIVATION]: ({ state }) => ({
    ...state,
    isActivationInProgress: true,
  }),
  [OR_ACTIVATION_SUCCESS]: ({ state }) => ({
    ...state,
    isActivationInProgress: false,
    isActivationRequestError: false,
  }),
  [OR_ACTIVATION_ERROR]: ({ state }) => ({
    ...state,
    isActivationInProgress: false,
    isActivationRequestError: true,
  }),
  [OR_SHOW_CANCEL_SUBSCRIPTION_MODAL]: ({ state }) => ({
    ...state,
    isCancelSubscriptionModalVisible: true,
    isCancelSubscriptionError: false,
  }),
  [OR_HIDE_CANCEL_SUBSCRIPTION_MODAL]: ({ state }) => ({
    ...state,
    isPutOnHoldInProgress: false,
    isPutOnHoldRequestError: false,
    isCancelSubscriptionModalVisible: false,
    isCancelSubscriptionInProgress: false,
    isCancelSubscriptionError: false,
  }),
  [OR_REQUEST_CANCEL_SUBSCRIPTION]: ({ state }) => ({
    ...state,
    isPutOnHoldInProgress: false,
    isPutOnHoldRequestError: false,
    isCancelSubscriptionInProgress: true,
  }),
  [OR_SUBSCRIPTION_CANCELLATION_SUCCESS]: ({ state }) => ({
    ...state,
    isCancelSubscriptionModalVisible: false,
    isCancelSubscriptionInProgress: false,
    isCancelSubscriptionError: false,
  }),
  [OR_SUBSCRIPTION_CANCELLATION_ERROR]: ({ state }) => ({
    ...state,
    isCancelSubscriptionInProgress: false,
    isCancelSubscriptionError: true,
  }),
};

export default function membershipReducer(state = initialState, action) {
  return ACTIONS[action.type] ? ACTIONS[action.type]({ state, action }) : state;
}
